import { hoverDynamic } from './hover';

export function drawer() {
  function drawerInit() {
    document.body.classList.remove('is-drawer-active');
    setTimeout(() => {
      document.body.classList.remove('is-disable-scroll-direction');
    }, 100)
    const drawerStyle = document.querySelector('.drawer-color');
    drawer.innerHTML = '';
    if(drawerStyle) drawerStyle.remove();
  }

  // ドロワーハンドラ
  function drawerHandler() {
    document.body.classList.remove('is-nav-active', 'is-search-active');
    document.body.classList.add('is-drawer-active', 'is-disable-scroll-direction');
    const hov = drawer.querySelectorAll('a, button, .hov');
    if(hov.length) {
      hov.forEach((el,index) => {
        hoverDynamic(el);
      })
    }
  }

  const drawer = document.querySelector('.js-drawer');
  const drawerClose = document.querySelectorAll('.js-drawer-close');
  
  // WORKSドロワー
  const worksPushTrigger = document.querySelectorAll('[data-works-id]');
  if(worksPushTrigger.length){
    worksPushTrigger.forEach((el, index) => {
      const worksid = el.dataset.worksId;
      el.addEventListener('click', function(e) {
        e.preventDefault();
        if(worksid && worksData) {
          const foundElement = worksData.find((element) => element['id'] == worksid);
          if(foundElement && drawer) {
            //console.log(foundElement);
            const l = foundElement['label']
            const t = foundElement['title']
            const ts = foundElement['titleSub']
            const i = foundElement['image']
            const de = foundElement['description']
            const ta = foundElement['tags']
            const p = foundElement['projects']
            const c = foundElement['collaborators']
            const li = foundElement['links']
            const pr = foundElement['permalink']

            if(l){
              const drawerLabel = document.createElement('p');
              drawerLabel.classList.add('font-display');
              drawerLabel.innerHTML = l;
              drawer.appendChild(drawerLabel);
            }

            if(t){
              const drawerTitle = document.createElement('h1');
              drawerTitle.classList.add('rowm-1_5', 'textsize-large', 'font-display');
              drawerTitle.innerHTML = `<b>${t}</b>`;
              drawer.appendChild(drawerTitle);
            }

            if(ts){
              const drawerTitleSub = document.createElement('p');
              drawerTitleSub.classList.add('rowm-1_5');
              drawerTitleSub.innerHTML = ts;
              drawer.appendChild(drawerTitleSub);
            }

            if(ta.length){
              const drawerTag = document.createElement('div');
              drawerTag.classList.add('rowm-2','flex', 'lh2');
              ta.forEach((taa, index) => {
                const el = document.createElement('p');
                const url = taa['url'];
                const label = taa['label'];
                el.innerHTML = `<a href="${url}" class="button-small"><b>${label}</b></a>`;
                drawerTag.appendChild(el);
              })
              drawer.appendChild(drawerTag);
            }

            if(i){
              const w = foundElement['imageW']
              const h = foundElement['imageH']
              const drawerImage = document.createElement('img');
              drawerImage.classList.add('rowm-3');
              drawerImage.setAttribute('src', i);
              drawerImage.setAttribute('loading', 'lazy');
              if(w && h) drawerImage.style.aspectRatio = `${w}/${h}`;
              drawer.appendChild(drawerImage);
            }

            if(de){
              const drawerDescription = document.createElement('div');
              drawerDescription.classList.add('rowm-3', 'text');
              drawerDescription.innerHTML = de;
              drawer.appendChild(drawerDescription);
            }

            if(p.length){
              const drawerProject = document.createElement('div');
              drawerProject.classList.add('rowm-6');
              const hr = document.createElement('hr');
              drawerProject.appendChild(hr);
              const el = document.createElement('p');
              el.classList.add('style-image', 'pt-1');
              el.innerHTML = '属するプロジェクト';
              drawerProject.appendChild(el);
              const ell = document.createElement('div');
              ell.classList.add('pt-1','pl-1_5');
              p.forEach((pp, index) => {
                const el = document.createElement('p');
                el.classList.add('rowm-0_5');
                const permalink = pp['permalink'];
                const title = pp['title'];
                el.innerHTML = `<a href="${permalink}" class="link-underline"><b>${title}</b></a>`;
                ell.appendChild(el);
              })
              drawerProject.appendChild(ell);
              drawer.appendChild(drawerProject);
            }

            if(c.length){
              const drawercollaborator = document.createElement('div');
              drawercollaborator.classList.add('rowm-4');
              const hr = document.createElement('hr');
              drawercollaborator.appendChild(hr);
              const el = document.createElement('p');
              el.classList.add('style-image', 'pt-1');
              el.innerHTML = 'コラボレーター';
              drawercollaborator.appendChild(el);
              const ell = document.createElement('ul');
              ell.classList.add('pt-1','pl-1_5');
              c.forEach((cc, index) => {
                const el = document.createElement('li');
                el.classList.add('rowm-0_5','rowm-1-sp');
                const permalink = cc['permalink'];
                const title = cc['title'];
                const role = cc['role'];
                if(role != '') {
                  el.innerHTML = `<a href="${permalink}" class="link-underline"><b>${title}</b></a> <span class="textcolor-primarysub db-sp pl-1-sp">${role}</span>`;
                } else {
                  el.innerHTML = `<a href="${permalink}" class="link-underline"><b>${title}</b></a>`;
                }
                ell.appendChild(el);
              })
              drawercollaborator.appendChild(ell);
              drawer.appendChild(drawercollaborator);
            }

            if(li.length){
              const drawerlink = document.createElement('div');
              drawerlink.classList.add('rowm-6');
              const hr = document.createElement('hr');
              drawerlink.appendChild(hr);
              const el = document.createElement('p');
              el.classList.add('style-image', 'pt-1');
              el.innerHTML = '関連リンク';
              drawerlink.appendChild(el);
              const ell = document.createElement('ul');
              ell.classList.add('liststyle-circle','pt-1','pl-1_5');
              li.forEach((lii, index) => {
                const el = document.createElement('li');
                el.classList.add('rowm-0_5');
                const url = lii['url'];
                const title = lii['title'];
                el.innerHTML = `<a href="${url}" class="link-underline"><b>${title}</b></a>`;
                ell.appendChild(el);
              })
              drawerlink.appendChild(ell);
              drawer.appendChild(drawerlink);
            }

            if(pr){
              const drawerPermaLink = document.createElement('div');
              drawerPermaLink.classList.add('rowm-6');
              const hr = document.createElement('hr');
              drawerPermaLink.appendChild(hr);
              const el = document.createElement('p');
              el.classList.add('textalign-center', 'pt-2');
              el.innerHTML = `<a href="${pr}" class="link-underline"><b>個別のページへ</b></a>`;
              drawerPermaLink.appendChild(el);
              drawer.appendChild(drawerPermaLink);
            }

            drawerHandler();
          }
        }
      })
    })
  }

  if(drawerClose.length){
    drawerClose.forEach((el, index) => {
      el.addEventListener('click', function(e) {
        e.preventDefault();
        drawerInit();
      })
    })
  }
}